/** See api/types/reservationStats.ts for the full confirmation notes (live curl
 *  round-trip against the local dev backend, 2026-08-10). */
import { apiPost } from '../client';
import type { ReservationStatsRequest, ReservationStatsResponse } from '../types/reservationStats';

export function getReservationStats(body: ReservationStatsRequest): Promise<ReservationStatsResponse> {
  return apiPost<ReservationStatsRequest, ReservationStatsResponse>('ReservationStats/GetReservationStats', body);
}
